import { CookingStationName, FCStatus, FoodComponent } from '../../../../libs';
import { getFoodComponentStatusAttributes } from '../../../../libs/utils/helperFunctions';
import { getCombinedShortages } from '../../ComponentsCheckHelpers';
import { MobileSectionTableRow } from '../SectionTableRow';

interface SectionProps {
  foodComponent: FoodComponent;
  selectedComponentStation: CookingStationName;
  setSelectedComponentStation: (value: CookingStationName) => void;
  highlightedComponentId?: string | null;
  onHighlightEnd?: () => void;
  showAllUnits: boolean;
  selectedHours: string;
}

const Section = ({
  foodComponent,
  selectedComponentStation,
  setSelectedComponentStation,
  highlightedComponentId,
  onHighlightEnd,
  showAllUnits,
  selectedHours
}: SectionProps) => {
  const combinedShortages = getCombinedShortages(foodComponent.shortages, selectedComponentStation);

  return (
    <>
      <MobileSectionTableRow
        showAllUnits={showAllUnits}
        key={foodComponent.id}
        foodComponent={foodComponent}
        statusAttributes={getFoodComponentStatusAttributes(foodComponent.cookingStations ?? [], selectedComponentStation)}
        selectedComponentStation={selectedComponentStation}
        setSelectedComponentStation={setSelectedComponentStation}
        isChecked={Boolean(
          foodComponent.cookingStations?.some(
            (station) => station.name === selectedComponentStation && station.status === FCStatus.completed
          )
        )}
        highlight={highlightedComponentId === foodComponent.id}
        onHighlightEnd={onHighlightEnd}
        selectedHours={selectedHours}
      />
      {combinedShortages
        ? Object.entries(combinedShortages).map(
            ([type, shortages]) =>
              shortages.ids.length > 0 && (
                <MobileSectionTableRow
                  showAllUnits={showAllUnits}
                  key={shortages.ids.join(';')}
                  foodComponent={foodComponent}
                  isChecked={type === 'completed' ? true : false}
                  statusAttributes={getFoodComponentStatusAttributes(shortages.cookingStations, selectedComponentStation)}
                  selectedComponentStation={selectedComponentStation}
                  setSelectedComponentStation={setSelectedComponentStation}
                  combinedShortages={shortages}
                  selectedHours={selectedHours}
                />
              )
          )
        : ''}
    </>
  );
};

export default Section;
